export const PERMISSOES_BASEADAS_TITLE = 'Preencher Permissões Baseadas em';
export const COMPARACAO_PERMISSOES_TITLE = 'Comparar Permissões com';
export const APLICAR_TITLE = 'Aplicar';
export const COMPARAR_TITLE = 'Comparar';
